import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function UpisniRokovi() {
  const [t] = useTranslation();

  return (
    <>
      <Navbar />
      <Bredcom title={t("breadcrumb.home")} subtitle={t("konkurs.zaupis")} />

      <div className="admissions-page">
        <div className="container mt-4 pt-40">
          {/* HERO */}
          <section className="admissions-hero" aria-label={t("konkurs.zaupis")}>
            <div className="admissions-hero__inner">
              <div className="admissions-hero__copy">
                <div className="admissions-eyebrow">
                  {t("admissionsPage.eyebrow")}
                </div>
                <h1 className="admissions-hero__title">
                  {t("konkurs.zaupis")}
                </h1>
                <p className="admissions-hero__subtitle">
                  {t("admissionsPage.konkurs.heroSubtitle")}
                </p>

                <div className="admissions-hero__cta">
                  <Link
                    className="admissions-btn admissions-btn--primary"
                    to="/upis"
                  >
                    {t("admissionsPage.cta.upisInfo")}
                    <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                  <Link
                    className="admissions-btn admissions-btn--secondary"
                    to="/svi-studijski-programi"
                  >
                    {t("admissionsPage.cta.programs")}
                    <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                  <a
                    className="admissions-btn admissions-btn--ghost"
                    href="mailto:fpebar@gmail.com"
                  >
                    {t("admissionsPage.cta.email")}
                  </a>
                </div>

                <div className="admissions-quickfacts">
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.textbooks")}
                  </div>
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.platform")}
                  </div>
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.ects")}
                  </div>
                </div>
              </div>

              <div
                className="admissions-hero__panel"
                aria-label={t("admissionsPage.konkurs.panelTitle")}
              >
                <div className="admissions-panel__title">
                  {t("admissionsPage.konkurs.panelTitle")}
                </div>
                <div className="admissions-panel__text">
                  <strong>{t("konkurs.p1")}</strong> {t("konkurs.p2")}
                </div>

                <div className="admissions-panel__actions">
                  <a
                    className="admissions-btn admissions-btn--mini"
                    href="tel:+38268003113"
                  >
                    {t("admissionsPage.cta.call")} 068/003-113
                  </a>
                  <a
                    className="admissions-btn admissions-btn--mini"
                    href="tel:+38268011311"
                  >
                    {t("admissionsPage.cta.call")} 068/011-311
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* LAYOUT */}
          <div className="row admissions-layout">
            <div className="col-md-8">
              <div className="content-container admissions-content">
                <nav
                  className="admissions-anchor"
                  aria-label={t("admissionsPage.nav.aria")}
                >
                  <a href="#programi">
                    {t("admissionsPage.konkurs.nav.programs")}
                  </a>
                  <a href="#ukljuceno">
                    {t("admissionsPage.konkurs.nav.included")}
                  </a>
                  <a href="#kontakt">{t("admissionsPage.nav.contact")}</a>
                </nav>

                {/* STUDY LEVEL CARDS */}
                <section id="programi" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.konkurs.programsTitle")}
                  </h2>

                  <div className="admissions-cardgrid">
                    <article className="admissions-card">
                      <div className="admissions-card__head">
                        <h3 className="admissions-card__title">
                          {t("konkurs.osnovnetitle")}
                        </h3>
                        <div className="admissions-price admissions-price--plans">
                          <span className="admissions-price__label">
                            {t("konkurs.cijenaosnovneTitle")}
                          </span>
                          <div className="admissions-paymentRows">
                            <span>
                              <strong>1200 €</strong>
                              {t("skolarina.jednokratnoDoOktobra")}
                            </span>
                            <span>
                              <strong>1400 €</strong>
                              {t("skolarina.semestralno")}
                            </span>
                            <span>
                              <strong>1500 €</strong>
                              {t("skolarina.uratama")}
                            </span>
                          </div>
                        </div>
                      </div>

                      <p className="admissions-card__text">
                        {t("konkurs.osnovneopis")}
                      </p>

                      <ul className="admissions-linklist">
                        <li>
                          <Link to="/racunovodstvo-finansije-i-bankarstvo">
                            {t("konkurs.osnovne1")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/menadzment">
                            {t("konkurs.osnovne2")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/pravo-osnovne">
                            {t("konkurs.osnovne3")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                      </ul>
                    </article>

                    <article className="admissions-card admissions-card--notice">
                      <div className="admissions-card__head">
                        <h3 className="admissions-card__title">
                          {t("konkurs.specNoticeTitle")}
                        </h3>
                      </div>

                      <p className="admissions-card__text">
                        {t("konkurs.specNoticeText")}
                      </p>

                      <ul className="admissions-linklist">
                        <li>
                          <Link to="/specijalisticke-studije">
                            {t("konkurs.specNoticeCta")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/poslovna-ekonomija">
                            {t("specialistNotice.businessEconomics")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/ekonomija-javnog-sektora">
                            {t("specialistNotice.publicEconomics")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                      </ul>
                    </article>

                    <article className="admissions-card">
                      <div className="admissions-card__head">
                        <h3 className="admissions-card__title">
                          {t("konkurs.mastertitle")}
                        </h3>
                        <div className="admissions-price admissions-price--plans">
                          <span className="admissions-price__label">
                            {t("konkurs.cijenamasterTitle")}
                          </span>
                          <div className="admissions-paymentRows">
                            <span>
                              <strong>1500 €</strong>
                              {t("skolarina.jednokratnoDoOktobra")}
                            </span>
                            <span>
                              <strong>1700 €</strong>
                              {t("skolarina.semestralno")}
                            </span>
                            <span>
                              <strong>1800 €</strong>
                              {t("skolarina.uratama")}
                            </span>
                          </div>
                        </div>
                      </div>

                      <p className="admissions-card__text">
                        {t("konkurs.masteropis")}
                      </p>

                      <ul className="admissions-linklist">
                        <li>
                          <Link to="/poslovna-ekonomija">
                            {t("konkurs.master1")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/ekonomija-javnog-sektora">
                            {t("konkurs.master2")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/pravo-master">
                            {t("konkurs.master3")}{" "}
                            <i className="fas fa-long-arrow-alt-right" />
                          </Link>
                        </li>
                      </ul>
                    </article>
                  </div>
                </section>

                {/* INCLUDED */}
                <section id="ukljuceno" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.konkurs.includedTitle")}
                  </h2>

                  <div className="admissions-callout">
                    <p className="admissions-prose">
                      {t("konkurs.p3")}{" "}
                      <a
                        href="https://e-fpep.com/login/index.php?lang=sr_lt"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <strong>www.e-fpep.com</strong>
                      </a>
                      .
                    </p>

                    <ul className="admissions-list">
                      <li>{t("admissionsPage.konkurs.includes1")}</li>
                      <li>{t("admissionsPage.konkurs.includes2")}</li>
                      <li>{t("admissionsPage.konkurs.includes3")}</li>
                      <li>{t("admissionsPage.konkurs.includes4")}</li>
                    </ul>
                  </div>
                </section>

                {/* CONTACT */}
                <section id="kontakt" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.contact.title")}
                  </h2>

                  <p className="admissions-prose">
                    {t("konkurs.p4")}{" "}
                    <a
                      href="http://www.fpep.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong>www.fpep.me</strong>
                    </a>{" "}
                    {t("konkurs.p5")}{" "}
                    <a href="mailto:fpebar@gmail.com">
                      <strong>fpebar@gmail.com</strong>
                    </a>
                  </p>

                  <div className="admissions-contactgrid">
                    <div className="admissions-contactcard">
                      <div className="admissions-contactcard__k">
                        {t("admissionsPage.contact.locationLabel")}
                      </div>
                      <div className="admissions-contactcard__v">
                        {t("admissionsPage.contact.locationValue")}
                      </div>
                    </div>
                    <div className="admissions-contactcard">
                      <div className="admissions-contactcard__k">
                        {t("admissionsPage.contact.phoneLabel")}
                      </div>
                      <div className="admissions-contactcard__v">
                        <a href="tel:+38268003113">068/003-113</a> ·{" "}
                        <a href="tel:+38268011311">068/011-311</a>
                      </div>
                    </div>
                    <div className="admissions-contactcard">
                      <div className="admissions-contactcard__k">
                        {t("admissionsPage.contact.emailLabel")}
                      </div>
                      <div className="admissions-contactcard__v">
                        <a href="mailto:fpebar@gmail.com">fpebar@gmail.com</a>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-md-4 pt-10">
              <aside className="sidebar-widget admissions-sidebar">
                <section className="admissions-asidecard">
                  <div className="admissions-asidecard__title">
                    {t("admissionsPage.konkurs.sidebar.title")}
                  </div>
                  <div className="admissions-asidecard__text">
                    {t("admissionsPage.konkurs.sidebar.text")}
                  </div>
                  <div className="admissions-asidecard__actions">
                    <Link
                      className="admissions-btn admissions-btn--primary admissions-btn--block"
                      to="/upis"
                    >
                      {t("admissionsPage.cta.upisInfo")}
                      <i className="fas fa-long-arrow-alt-right" />
                    </Link>
                    <Link
                      className="admissions-btn admissions-btn--secondary admissions-btn--block"
                      to="/cijene-studija"
                    >
                      {t("admissionsPage.cta.tuition")}
                      <i className="fas fa-long-arrow-alt-right" />
                    </Link>
                  </div>
                </section>

                {/* ostavi postojeće widgete ispod */}

                <section
                  id="custom_html-5"
                  className="widget_text widget widget_custom_html"
                >
                  <h2 className="widget-title">{t("sidebar.follow")}</h2>
                  <div className="textwidget custom-html-widget">
                    <div className="widget-social">
                      <a
                        href="https://www.facebook.com/fpebar.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Facebook"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://www.instagram.com/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.youtube.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-youtube" />
                      </a>
                      <a
                        href="https://www.tiktok.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on Tiktok"
                        title="Tiktok"
                      >
                        <i className="fab fa-tiktok" />
                      </a>
                      <a
                        href="https://www.linkedin.com/school/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on LinkedIn"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </div>
                  </div>
                </section>
                <section id="categories-1" className="widget widget_categories">
                  <h2 className="widget-title">{t("sidebar.useful")}</h2>
                  <ul>
                    <li className="cat-item cat-item-16">
                      <Link to="/o-fpep">{t("about.fpep")}</Link>
                    </li>
                    <li className="cat-item cat-item-23">
                      <Link to="/akreditacija-fpep">
                        {t("admission.Akreditacija")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-18">
                      <Link to="/upis">{t("upis.title")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/cijene-studija">
                        {t("admission.Skolarina")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/projekti">{t("saradnja.projekti")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/galerija">{t("navbar.Gallery")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/novosti">{t("navbar.News")}</Link>
                    </li>
                  </ul>
                </section>
                <section
                  id="recent-posts-4"
                  className="widget widget_recent_entries"
                >
                  <h2 className="widget-title">{t("sidebar.study")}</h2>
                  <ul>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.osnovne")}</strong> <br />
                      </span>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">
                        {t("osnovne.menadzment")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">
                        {t("osnovne.pravo")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.master")}</strong> <br />
                      </span>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">
                        {t("master.pravo")}
                        <br />
                      </Link>
                    </li>

                    <li>
                      <span className="post-date">
                        <strong>{t("programs.specijalisticke")}</strong> <br />
                      </span>
                      <Link to="/specijalisticke-studije">
                        {t("konkurs.specNoticeCta")}
                        <br />
                      </Link>
                    </li>
                  </ul>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default UpisniRokovi;
